import React, { FC } from 'react';
import { Notification } from '../../../../interfaces/Notification';
import { StyledLink, StyledWarningIcon } from '../Content.styles';

export interface ActionRequiredLinksProps {
  actionsRequired: Notification[];
}

const ActionRequiredLinks: FC<ActionRequiredLinksProps> = ({ actionsRequired }) => {
  if ((actionsRequired?.length ?? 0) === 0) return null;

  return (
    <div>
      {actionsRequired?.map((n) => (
        <StyledLink
          href={n.url}
          tabIndex={0}
          key={n.id}
          LeftIcon={StyledWarningIcon}
        >{n.text}
        </StyledLink>
      ))}
    </div>
  );
};

export default ActionRequiredLinks;
